import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/Page";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import Loader from "../../components/Loader/Loader";
import {
  boardcastDataClear,
  fetchBoardcast,
  fetchBoardcastClear,
  sessionWatchURLDataClear,
} from "../../redux/events/actions";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import VideoBroadcastSection from "../../components/Video/VideoBroadcastSection";

const VideoPlayerBroadcastPage = () => {

  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <Loader start={isLoading} />
      <Page>
        <VideoBroadcastSection 
          isMobile={false}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </Page>
    </>
  );
};

export default VideoPlayerBroadcastPage;
